import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as QuestionnaireActions from '../../actions/questionnaire_actions';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

let Weekly = React.createClass({
    getInitialState() {
        return {
            weeklySurveyData: [],
            isQuestionEdited: false,
            isFieldEmpty: false
        }
    },
    componentWillReceiveProps(nextProps) {
        this.getWeeklyData(nextProps.weekly);
    },
    componentDidMount() {
        this.props.Dispatch(QuestionnaireActions.questionnaire());
    },
    loginHandler() {


    },

    navigationHandler() {
    },
    getWeeklyData(data) {
        var weekData = [];
        data.forEach(element => {
            element.isEdit = false;
            weekData.push(element);
        });

        this.setState({ weeklySurveyData: weekData });

    },
    isEdit(index) {
        let weeklyUpdateData = this.state.weeklySurveyData;
        weeklyUpdateData[index].isEdit = weeklyUpdateData[index].isEdit ? false : true;
        weeklyUpdateData.filter((data, i) => {
            if (i !== index) {
                return data.isEdit = false;
            }
        });
        this.setState({ weeklySurveyData: weeklyUpdateData });
        if (!weeklyUpdateData[index].isEdit) {
            this.setState({ isQuestionEdited: false })
            delete weeklyUpdateData[index].isEdit;
            this.props.Dispatch(QuestionnaireActions.weeklySurveyUpdate(weeklyUpdateData[index]));
        }
    },

    updateValue(e, i) {
        let weeklyNameUpdate = this.state.weeklySurveyData;
        if (e.target.value === '' || e.target.value[0].trim() === '') {
            this.setState({ isFieldEmpty: true })
        } else {
            weeklyNameUpdate[i].name = e.target.value;
            this.setState({ weeklySurveyData: weeklyNameUpdate, isFieldEmpty: false, isQuestionEdited: true });
        }
    },

    render() {
        return (
            <div>
                <div role="tabpanel" className="tab-pane" id="weekly">
                    <div className="daily-questions medication answers-all">
                        <p className="daily-paragraph">Rated on a 1 – 5 likert scale</p>
                        <button className="white-button">1 = not at all</button>
                        <button className="white-button">3 = half the time</button>
                        <button className="white-button">5 = most of the time</button>
                    </div>
                    <div className="daily-questions socialize">
                        <ol>
                            {this.state.weeklySurveyData && this.state.weeklySurveyData.map((data, index) => {
                                return (
                                    <div key={index} className='w-q'>
                                        <li>
                                            <div>
                                                <input type='text' defaultValue={data.name} id={data.id} disabled={!data.isEdit}
                                                    className={'w-q-input'} autoComplete='off'
                                                    onChange={(e) => { this.updateValue(e, index) }} />
                                                {!data.isEdit && <button onClick={() => { this.isEdit(index) }} className={this.state.isFieldEmpty || this.state.isQuestionEdited ? 'edit-btn disabled' : 'edit-btn'}>Edit</button>}
                                                {data.isEdit && <button onClick={() => { this.isEdit(index) }} className={this.state.isFieldEmpty ? 'update-btn disabled' : 'update-btn'}>Update</button>}
                                            </div>
                                        </li>
                                    </div>
                                )
                            })}
                        </ol>
                    </div>
                </div>
            </div>

        );
    }
});

let mapStateToProps = (state) => {
    var weekly = _.flatten(state.Questionnaire.QuestionnaireWeekly);
    return {
        weekly: weekly
    };
};

let mapDispatchToProps = (dispatch) => ({
    QuestionnaireActions: bindActionCreators(QuestionnaireActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(Weekly));




/** WEBPACK FOOTER **
 ** ./src/components/questionnaireScreen/weekly.js
 **/